export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4772.ee2a5155.jpg";